<script setup>
/* Eine Spalte der Übersicht: Überschrift, Beschreibung, Anzahl — darunter die
   Zeilen. Im Original waren das drei Blöcke (Kader, Transferiert,
   Freigegeben) mit identischem Aufbau.

   Optional zuklappbar (`collapsible`): Die Kopfzeile wird dann zum Knopf.
   Ohne `storageKey` gilt der Zustand nur für diese Sitzung; mit ihm wird er
   pro Gerät gemerkt. Geschlossen ist die Vorgabe. Die Kaderspalte setzt
   `collapsible` nicht und bleibt immer offen. */
import { ref } from 'vue';
import { useStoredToggle } from '../composables/useStoredToggle.js';

const props = defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  count: { type: Number, required: true },
  collapsible: { type: Boolean, default: false },
  /* Kopf nur für Screenreader sichtbar (Handy seit F2, Laptop seit F3) */
  srOnlyHead: { type: Boolean, default: false },
  storageKey: { type: String, default: '' },
});

const open = props.collapsible ? useStoredToggle(props.storageKey, false) : ref(true);

function toggle() {
  if (props.collapsible) open.value = !open.value;
}
</script>

<template>
  <div class="col">
    <!-- Tastatur: Bei zuklappbarer Spalte ist die Kopfzeile ein echter
         <button>, kein <div> mit @click. Gleiche Idee wie in PlayerAvatar.vue. -->
    <component
      :is="collapsible ? 'button' : 'div'"
      class="col-head"
      :class="{ 'col-toggle': collapsible, 'head-sr': srOnlyHead }"
      :role="collapsible ? undefined : 'heading'"
      :aria-level="collapsible ? undefined : 2"
      :type="collapsible ? 'button' : undefined"
      :aria-expanded="collapsible ? open : undefined"
      @click="toggle"
    >
      <span class="col-head-text">
        <span class="title">{{ title }}</span>
        <span v-if="description && open" class="desc">{{ description }}</span>
      </span>
      <span class="count mono">
        {{ $t('squad.playerCount', { count }) }}
        <span v-if="collapsible" class="chevron" aria-hidden="true">{{ open ? '▾' : '▸' }}</span>
      </span>
    </component>
    <slot v-if="open" />
  </div>
</template>
